import { render, staticRenderFns } from "./ideaFlow.vue?vue&type=template&id=3bdb8d0b&scoped=true"
import script from "./ideaFlow.vue?vue&type=script&lang=js"
export * from "./ideaFlow.vue?vue&type=script&lang=js"
import style0 from "./ideaFlow.vue?vue&type=style&index=0&id=3bdb8d0b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bdb8d0b",
  null
  
)

export default component.exports